import { FormattedMessage } from 'react-intl'
import React from 'react'
import { toRoman } from 'helpers'

export const LEVEL_BONUSES = (level) => (
    <FormattedMessage
        id='reserve_tooltip_body.bonuses'
        defaultMessage='Level {level} bonuses'
        values={{ level: toRoman(level) }}
    />
)



// WEBPACK FOOTER //
// ./components/ReserveTooltip/components/constants.jsx